import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import NotFoundVector from 'assets/vectors/NotFound.svg';
import Button from 'components/Button';
import './index.css';

function NotFound() {
    const navigate = useNavigate();

    return (
        <div className='layout notFound'>
            <Helmet>
                <title>
                    404 Not Found
                </title>
            </Helmet>
            <img
                className='notFound__image'
                src={NotFoundVector}
                alt='Page Not Found'
            />
            <h1 className='notFound__title'>
                Page Not Found.
            </h1>
            <p className='notFound__text'>
                Seems like the page you are looking for doesn't exist.
            </p>
            <Button
                className='notFound__button'
                onClick={() => navigate(-1)}
            >
                GO BACK
            </Button>
        </div>
    );
}

export default NotFound;